export const removeTrailingSlash = function() {
  return function(input) {
    if (!input) return;
    return input.replace(/\/$/,'');
  }
};